import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { CrownIcon } from './icons/GoldIcons';
export function BrandPromise() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full overflow-hidden bg-ink-800 py-24 sm:py-28" data-id="element-18" data-mp="kt2n6dctcsnm">
      <div className="pointer-events-none absolute left-1/2 top-0 h-64 w-[42rem] -translate-x-1/2 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(212,168,87,0.16),transparent_70%)]" aria-hidden="true" data-id="element-19" data-mp="kqyhpqz9nll8" />
      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-20" data-mp="3k8ptpgannma9">
        <CrownIcon className="mx-auto h-9 w-9 text-gold-soft" data-id="element-21" data-mp="3k6d54kae6do8" />
        <p className="mt-8 font-display text-2xl italic leading-snug text-neutral-200 sm:text-3xl" data-id="element-22" data-mp="1v8igbipx3b1">
          {t.brandPromise.quote}
        </p>
        <p className="mx-auto mt-8 max-w-2xl leading-relaxed text-neutral-400" data-id="element-23" data-mp="3t7bb384e4v9g">
          {t.brandPromise.body}
        </p>

        <dl className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-gold-deep/25 bg-gold-deep/25 sm:grid-cols-3" data-id="element-24" data-mp="30l0b9zolyydp">
          {t.brandPromise.stats.map(stat => <div key={stat.label} className="bg-ink-800 px-6 py-8" data-id="element-25" data-mp="3gwvl5zn2yy1p">
              <dt className="sr-only" data-id="element-26" data-mp="3gv0yogw5uxvi">{stat.label}</dt>
              <dd data-id="element-27" data-mp="3ln28zx9rqeiw">
                <span className="gold-shine block font-display text-4xl font-semibold" data-id="element-28" data-mp="3lon4bp3wq1ht">
                  {stat.value}
                </span>
                <span className="mt-2 block text-[11px] uppercase tracking-[0.24em] text-neutral-500" data-id="element-29" data-mp="3qohshkwascz6">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}